import script from "./WorldMap.vue?vue&type=script&setup=true&lang=js"
export * from "./WorldMap.vue?vue&type=script&setup=true&lang=js"

import "./WorldMap.vue?vue&type=style&index=0&id=5c6ddb3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c6ddb3e"]])

export default __exports__